import React from 'react'
import MaskedInput from 'react-text-mask'

import { cnpjMask, cpfMask, phoneMask } from 'utils/masks'
import Container from './styles'

const masks = {
  cpf: cpfMask,
  cnpj: cnpjMask,
  phone: phoneMask,
}

export default (props) => {
  const { label, field, form, mask, multiline } = props
  const { errors, setFieldValue } = form
  const { name } = field

  return (
    <Container>
      <div className="textinput">
        <label
          className={`textinput__label ${
            errors[name] ? 'textinput__label--error' : ''
          }`}
          htmlFor={name}
        >
          {label}
        </label>
        {!mask ? (
          !multiline ? (
            <input
              {...props}
              {...field}
              className={`textinput__input ${
                errors[name]
                  ? 'textinput__input--error'
                  : ''
              }`}
              id={name}
              onChange={(e) =>
                setFieldValue(name, e.target.value)}
            />
          ) : (
            <textarea
              {...props}
              {...field}
              className={`textinput__area ${
                errors[name] ? 'textinput__area--error' : ''
              }`}
              id={name}
              onChange={(e) => setFieldValue(name, e.target.value)}
            />
          )
        ) : (
          <MaskedInput
            {...props}
            {...field}
            mask={masks[mask]}
            className={`textinput__input ${
              errors[name] ? 'textinput__input--error' : ''
            }`}
            id={name}
            onChange={(e) => setFieldValue(name, e.target.value)}
          />
        )}

        <div className="textinput__error">{errors[name]}</div>
      </div>
    </Container>
  )
}
